<template>
  <el-dialog title="考试列表" :visible.sync="dialogVisible" :before-close="handleClose" width="75%"
    style="top: -6vh;font-weight: bold;">
    <el-tabs v-model="activeName" @tab-click="handleClick" style="padding: 0 40px 20px;">
      <el-tab-pane label="报名中" name="first" style="font-weight: bold;">
        <el-table style="width: 100%;" :data="examList" height="58vh">
          <el-table-column prop="name" label="考试名称" align="center" show-overflow-tooltip />
          <el-table-column prop="signEndDate" label="报名截止时间" align="center" show-overflow-tooltip>
            <template slot-scope="{ row }">
              {{ row.signEndDate | fmDate("YYYY-MM-DD") }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <el-button size="mini" type="primary" @click="handleConfirm(row)">
                报名
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="报名截止" name="second">
        <el-input v-model="keyword" size="small" @input="handleInput" placeholder="请输入考试名称" clearable />
        <el-table style="width: 100%;" :data="dataList" height="calc(58vh - 30px)" v-loading="loading">
          <el-table-column prop="name" label="考试名称" align="center" show-overflow-tooltip />
          <el-table-column prop="signEndDate" label="报名截止时间" align="center" show-overflow-tooltip>
            <template slot-scope="{ row }">
              {{ row.signEndDate | fmDate("YYYY-MM-DD") }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <el-button size="mini" type="primary" @click="handleConfirm(row)">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

  </el-dialog>
</template>

<script>
// vuex
import { mapGetters, mapMutations, mapActions } from "vuex";
import * as ExamApi from "@/api/exam/index";
import dayjs from "dayjs";

export default {
  data() {
    return {
      dialogVisible: false,
      dataList: [],
      activeName: "first",
      keyword: "",
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["examList"]),
  },
  methods: {
    ...mapMutations(["SET_CURRENT_EXAM_ID"]),
    ...mapActions(["fetchExamDataList", "fetchExamInfoById"]),
    handleClose(done) {
      done();
    },
    async handleConfirm(row) {
      await this.SET_CURRENT_EXAM_ID(row.id);
      await this.fetchExamInfoById();
      // 直接进入该考试的报名须知（报名流程首页），避免闪出菜单
      const routeUrl = this.$router.resolve({
        name: "exam-notice",
      });
      window.open(routeUrl.href);
    },
    async open() {
      try {
        await this.fetchExamDataList();
        this.dialogVisible = true;
      } catch (error) {
        console.error("Failed to fetch exam data:", error);
      }
    },
    handleClick(tab) {
      this.activeName = tab.name;
      if (this.activeName == 'second') {
        this.handleInput();
      }
    },
    handleInput() {
      try {
        this.loading = true;
        ExamApi.page({ name: this.keyword })
          .then((res) => {
            this.dataList = res.list || [];
          })
      } catch (error) { } finally {
        this.loading = false;
      }

    },
  },
};
</script>

<style scoped></style>
